module.exports = __webpack_public_path__ + "img/product-shot_01_loading.ab3892f8.jpg";